import logo from './logo.svg';
import Home from './Pages/Home'

import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
// import { Routes } from 'react-router-dom';
import { IndexRoute, browserHistory, Switch } from 'react-router';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Routes from './Routes/Routes';
import './App.css';
function App() {

  return (

    <Router>

      <Routes/>
      {/*  <Route*/}
      {/*    exact*/}
      {/*    path="/"*/}
      {/*    element={*/}
      {/*      <Home />*/}
      {/*    }*/}
      {/*  />*/}
      {/*</Routes>*/}
    </Router>

  );

}


export default App;
